/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontWebPodcastProgramModel
 */
export interface FrontWebPodcastProgramModel {
    /**
     * Id
     * @type {number}
     * @memberof FrontWebPodcastProgramModel
     */
    id: number;
    /**
     * Slug
     * @type {string}
     * @memberof FrontWebPodcastProgramModel
     */
    slug: string;
    /**
     * Name
     * @type {string}
     * @memberof FrontWebPodcastProgramModel
     */
    name: string;
    /**
     * Image
     * @type {string}
     * @memberof FrontWebPodcastProgramModel
     */
    logo: string;
    /**
     * og logo
     * @type {string}
     * @memberof FrontWebPodcastProgramModel
     */
    ogLogo: string;
    /**
     * Episodes count
     * @type {number}
     * @memberof FrontWebPodcastProgramModel
     */
    episodesCount: number;
    /**
     * meta description
     * @type {string}
     * @memberof FrontWebPodcastProgramModel
     */
    metaDescription: string;
}

/**
 * Check if a given object implements the FrontWebPodcastProgramModel interface.
 */
export function instanceOfFrontWebPodcastProgramModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "logo" in value;
    isInstance = isInstance && "ogLogo" in value;
    isInstance = isInstance && "episodesCount" in value;
    isInstance = isInstance && "metaDescription" in value;

    return isInstance;
}

export function FrontWebPodcastProgramModelFromJSON(json: any): FrontWebPodcastProgramModel {
    return FrontWebPodcastProgramModelFromJSONTyped(json, false);
}

export function FrontWebPodcastProgramModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontWebPodcastProgramModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'slug': json['slug'],
        'name': json['name'],
        'logo': json['logo'],
        'ogLogo': json['ogLogo'],
        'episodesCount': json['episodesCount'],
        'metaDescription': json['metaDescription'],
    };
}

export function FrontWebPodcastProgramModelToJSON(value?: FrontWebPodcastProgramModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'slug': value.slug,
        'name': value.name,
        'logo': value.logo,
        'ogLogo': value.ogLogo,
        'episodesCount': value.episodesCount,
        'metaDescription': value.metaDescription,
    };
}

